import { CSSTransition } from 'react-transition-group';

import { useGetParams } from './hooks/useGetParams';
import { useMultiBroadcast } from './hooks/useMultiBroadcast';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import MessageGroup from './components/MessageGroup/MessageGroup';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';

function App() {
  const { cols, authorFontSize, msgFontSize, bgVideo, bgPoster } =
    useGetParams();
  const { currentState, showedMessages, isVisible } = useMultiBroadcast();

  return (
    <div className="app-wrapper">
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <AdvtFullSize />
      </CSSTransition>
      <CSSTransition
        in={isVisible && currentState && currentState === 'S1'}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <div className="titre-wrapper">
          <MessageGroup
            cols={cols}
            messages={showedMessages}
            authorFontSize={authorFontSize}
            msgFontSize={msgFontSize}
          />
        </div>
      </CSSTransition>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          id="bgVideo"
          poster={bgVideo === '1' ? posterDefault : bgPoster}
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
